module.exports = __webpack_public_path__ + "images/common/estimate_btn-big_ebd66cd4eae54a432a9b2aa86e06b082.gif";